import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import TrfToStoreProcessActions, {
  TrfToStoreProcessTypes
} from '../Stores/TrfToStoreProcess/Actions';

const getAppStore = state => state.app;

// eslint-disable-next-line import/prefer-default-export
export function* trfToStoreProcessFetchTrfToStoreProcess() {
  try {
    yield put(TrfToStoreProcessActions.trfToStoreProcessFetchTrfToStoreProcessLoading(true));

    const app = yield select(getAppStore);
    const getData = {};

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `division/indexTransferToStoreFlow/${app.curDivisionId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );
    if (result.isSuccess === true) {
      yield put(
        TrfToStoreProcessActions.trfToStoreProcessFetchTrfToStoreProcessSuccess(result.data)
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(TrfToStoreProcessActions.trfToStoreProcessFetchTrfToStoreProcessLoading(false));
  }
}

export const saga = [
  takeLatest(
    TrfToStoreProcessTypes.TRF_TO_STORE_PROCESS_FETCH_TRF_TO_STORE_PROCESS,
    trfToStoreProcessFetchTrfToStoreProcess
  )
];
